
/**
 * @export
 * @enum {string}
 */
export enum GeneralAlertType {
    SAVED_SEARCH = 'SAVED_SEARCH',
    SAVED_LIST = 'SAVED_LIST'
}